import { useNavigate } from "react-router";
import PageAnimation from "../../Other/PageAnimation";
import Button from "../../UI/Button";
import DataContext from "../../store/data-context";
import styles from "./HomePage.module.css";
import AboutUs from "./comp/AboutUs,";
import CategoryList from "./comp/CategoryList";
import Header from "./comp/Header";
import MarketLink from "./comp/MarketLink";
import Partners from "./comp/Partners";
import { useContext, useEffect } from "react";

export default function HomePage() {
  const dataCtx = useContext(DataContext);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageAnimation>
      <header>
        <Header galleries={dataCtx.galleries} />
      </header>
      <main>
        <Partners dataCtx={dataCtx} />
        <MarketLink />
        <CategoryList
          categories={dataCtx.categories}
          pageData={dataCtx.pageData.categories}
        />
        <AboutUs />
        <div className={styles[`references-button`]}>
          <Button
            onClick={() => {
              dataCtx.lang.lang === "hr"
                ? navigate("/hr/reference")
                : navigate("/de/verweise");
            }}
          >
            {dataCtx.pageData.references.reference_button}
          </Button>
        </div>
      </main>
    </PageAnimation>
  );
}
